import { cloneElement } from "react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { Label } from "@ui/label";
import { Switch } from "@ui/switch";

export const FIELD_ICON_CLASS = "h-4 w-4 shrink-0 text-slate-400";

export const FIELD_TRIGGER_CLASS = "h-9 bg-white text-sm";
// Never wider than the trigger, so a long persona label wraps on a phone
// instead of running off the screen.
export const FIELD_CONTENT_CLASS =
  "max-w-[var(--radix-select-trigger-width)] [&_[role=option]]:whitespace-normal";

export const SadieSimulatorField = ({
  children,
  icon,
  id,
  label,
}: {
  children: React.ReactNode;
  icon: React.ReactElement<{ className?: string }>;
  id: string;
  label: string;
}) => (
  <Column className="gap-1.5">
    <Row className="items-center gap-2">
      {cloneElement(icon, { className: FIELD_ICON_CLASS })}
      <Label className="text-sm font-medium text-slate-700" htmlFor={id}>
        {label}
      </Label>
    </Row>
    {children}
  </Column>
);

// A labelled on/off setting with a line saying what it does.
export const SadieSimulatorSwitchRow = ({
  checked,
  description,
  disabled,
  icon,
  id,
  label,
  onCheckedChange,
}: {
  checked: boolean;
  description: string;
  disabled: boolean;
  icon: React.ReactNode;
  id: string;
  label: string;
  onCheckedChange: (value: boolean) => void;
}) => (
  <Row className="items-center justify-between gap-3 py-1">
    <Row className="items-center gap-2">
      {icon}
      <Column className="gap-0">
        <Label className="text-sm font-medium text-slate-700" htmlFor={id}>
          {label}
        </Label>
        <Text className="text-xs text-slate-500">{description}</Text>
      </Column>
    </Row>
    <Switch
      checked={checked}
      disabled={disabled}
      id={id}
      onCheckedChange={onCheckedChange}
    />
  </Row>
);
